/**
 * Configuración modular de entregables (solo frontend).
 * Flujo único: /entregable/:id
 * IDs alineados con DeliverableDocumentPreview.jsx (on("id")).
 */

export const INFORME_CLINICO = "INFORME_CLINICO";
export const INFORME_FAMILIAR = "INFORME_FAMILIAR";
export const RESUMEN_CLINICO = "RESUMEN_CLINICO";

export const LEGACY_CLINICAL_REPORT = "clinical_report";
export const LEGACY_FAMILY_REPORT = "family_report";
export const LEGACY_SUMMARY = "summary";

export const DEFAULT_DELIVERABLE_TYPE = INFORME_CLINICO;

export const DELIVERABLE_TYPES = [
  { id: INFORME_CLINICO, label: "Informe clínico integral" },
  { id: INFORME_FAMILIAR, label: "Resumen para familia" },
  { id: RESUMEN_CLINICO, label: "Resumen clínico" },
];

const fixed = (id) => ({ id, fixed: true, defaultOn: true });
const optional = (id) => ({ id, fixed: false, defaultOn: true });

const MODULE_LABELS = {
  datosPaciente: "Datos del paciente",
  motivo: "Motivo de consulta",
  historia: "Historia clínica",
  antecedentes: "Antecedentes",
  examenFisico: "Examen físico",
  vgi: "Valoración geriátrica integral",
  diagnostico: "Diagnóstico",
  tratamientoFarmacologico: "Medicamentos y tratamiento",
  planNoFarmacologico: "Plan no farmacológico",
  recomendaciones: "Recomendaciones",
  evolucion: "Evolución clínica",
  dashboard: "Estado actual del paciente",
  resumenConsulta: "Resumen de consulta",
  planFarmacologico: "Plan farmacológico",
};

export function getModuleLabel(id) {
  return MODULE_LABELS[id] || id;
}

const PRESETS = {
  [INFORME_CLINICO]: [
    fixed("datosPaciente"),
    fixed("motivo"),
    fixed("vgi"),
    fixed("diagnostico"),
    optional("historia"),
    optional("antecedentes"),
    optional("examenFisico"),
    optional("tratamientoFarmacologico"),
    optional("planNoFarmacologico"),
    optional("recomendaciones"),
  ],
  [INFORME_FAMILIAR]: [
    fixed("datosPaciente"),
    fixed("dashboard"),
    fixed("recomendaciones"),
    optional("vgi"),
    optional("planFarmacologico"),
    optional("planNoFarmacologico"),
  ],
  [RESUMEN_CLINICO]: [
    fixed("datosPaciente"),
    fixed("motivo"),
    fixed("diagnostico"),
    optional("evolucion"),
    optional("tratamientoFarmacologico"),
    optional("resumenConsulta"),
  ],
};

const LEGACY_TYPE_MAP = {
  [LEGACY_CLINICAL_REPORT]: INFORME_CLINICO,
  [LEGACY_FAMILY_REPORT]: INFORME_FAMILIAR,
  [LEGACY_SUMMARY]: RESUMEN_CLINICO,
};

export function normalizeDeliverableTypeId(typeId) {
  if (!typeId || typeof typeId !== "string") return DEFAULT_DELIVERABLE_TYPE;
  return LEGACY_TYPE_MAP[typeId] || (PRESETS[typeId] ? typeId : DEFAULT_DELIVERABLE_TYPE);
}

export function getModuleDefinitions(typeId) {
  const key = normalizeDeliverableTypeId(typeId);
  return PRESETS[key] || PRESETS[INFORME_CLINICO];
}

export function buildInitialModuleState(typeId) {
  const defs = getModuleDefinitions(typeId);
  return defs.reduce((acc, m) => {
    acc[m.id] = m.defaultOn;
    return acc;
  }, {});
}
